var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 35,
    viewBox: "0 0 21 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31424 15.5597L15.7709 1.30029C16.8528 0.233235 18.6039 0.233235 19.6858 1.30029C20.7714 2.37112 20.7714 4.11016 19.6858 5.18099L7.19627 17.5L19.6858 29.819C20.7714 30.8898 20.7714 32.6289 19.6858 33.6997C18.6039 34.7668 16.8528 34.7668 15.7709 33.6997L1.31424 19.4403C0.22859 18.3695 0.22859 16.6305 1.31424 15.5597Z",
    fill: "#1264DE",
    stroke: "#1264DE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackChevron);
export default __webpack_public_path__ + "static/media/back-chevron.8ab6a509.svg";
export { ForwardRef as ReactComponent };